import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function ReviewsAdmin() {
  const [data, setData] = useState({ products: [], reviews: [] });
  useEffect(() => { api.get("/admin/reviews").then((r) => setData(r.data)); }, [api]);

  return (
    <div>
      <h1 className="font-serif text-3xl mb-6">Reviews</h1>
      <div className="grid md:grid-cols-4 gap-4 mb-8">
        {data.products.map((p) => (
          <div key={p.product_id} className="admin-surface p-5" data-testid={`admin-review-product-${p.product_id}`}>
            <p className="text-sm truncate">{p.product_name}</p>
            <p className="text-[#C5A059] text-lg mt-1">{"★".repeat(Math.round(p.avg))}<span className="text-[#27272A]">{"★".repeat(5 - Math.round(p.avg))}</span></p>
            <p className="text-xs text-[#8C867D] mt-1">{p.avg} avg · {p.count} review{p.count === 1 ? "" : "s"}</p>
          </div>
        ))}
        {data.products.length === 0 && <p className="text-sm text-[#8C867D] col-span-4">No reviews yet.</p>}
      </div>
      <div className="admin-surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[#8C867D] text-xs uppercase tracking-widest text-left">
            <tr><th className="p-3">Customer</th><th>Product</th><th>Rating</th><th>Review</th><th>Date</th></tr>
          </thead>
          <tbody>
            {data.reviews.map((r) => (
              <tr key={r.id} className="border-t border-[#27272A]">
                <td className="p-3">{r.customer_name}</td>
                <td className="text-xs">{r.product_name}</td>
                <td className="text-[#C5A059] whitespace-nowrap">{"★".repeat(r.rating)}</td>
                <td className="text-xs max-w-md"><p className="line-clamp-2">{r.text || "—"}</p></td>
                <td className="text-xs whitespace-nowrap">{new Date(r.created_at).toLocaleDateString("en-IN")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
